import React from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from '@mui/material/Typography';
import { Translate } from 'react-localize-redux';

import LinkButton from '@fd/ui/Button/LinkButton';

import { getPhoneNumbersPagePath } from './phoneNumbersPage';

type Props = {
  appId: string;
  propertyId: string;
};

/** Stands in for a legacy phone input once numbers are edited on the Phone numbers page. */
const PhoneNumbersMovedNotice = ({ appId, propertyId }: Props) => (
  <div data-fd="phone-numbers-moved-notice">
    <Typography variant="body2" color="textSecondary" gutterBottom>
      <Translate id="Phone_numbers_moved_helper" />
    </Typography>
    <LinkButton
      fdKey="manage-phone-numbers"
      variant="outlined"
      endIcon={<ArrowForwardIcon />}
      to={getPhoneNumbersPagePath({ appId, propertyId })}
    >
      <Translate id="Manage_phone_numbers" />
    </LinkButton>
  </div>
);

export default PhoneNumbersMovedNotice;
